import _ from 'lodash-es';
import { ignoreRelations } from '~/scripts/services/relations';
import $ from 'jquery';

/**
 * Function to remove accents and transform string in lowercase
 *
 * @param {string} s
 * @returns {string}
 */
const ul = s => s.normalize('NFKD').replaceAll(/[\u0300-\u036F]/g, '').toLowerCase() || '';

export default class ClassDesignerLinkEditorController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} Notification
	 */
	constructor(
		$injector,
		$scope,
		$timeout,
		$translate,
		Notification,
	) {
		this.$injector = $injector;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.Notification = Notification;

		/** @type {string} */
		this.active = '0';

		/** @type {string} */
		this.btntitle = '';

		/** @type {boolean} */
		this.create = false;

		/** @type {?string} */
		this.dicoId = null;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('~/components/class-designer/editor/class-designer-editor.controller').default} */
		this.editor = null;

		/** @type {?(import('angular').IFormController)} */
		this.form = null;

		/** @type {any[]} */
		this.nodes = [];

		/** @type {?string} */
		this.oldDicoId = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.oldType = null;

		/** @type {any[]} */
		this.relations = [];

		/** @type {?import('~/scripts/services/model/schema-link').default} */
		this.schemaLink = null;

		/**
		 * @type {?{
		 *   modified: boolean,
		 *   node: import('~/scripts/services/model/schema-link').default,
		 *   options: import('~/scripts/services/model/class-designer').DesignerPanelOptions
		 * }}
		 */
		this.selected = null;

		/** @type {import('~/scripts/services/model/schema-node').default | undefined} */
		this.source = undefined;

		/** @type {import('~/scripts/services/model/schema-node').default | undefined} */
		this.target = undefined;

		/** @type {any} */
		this.tmp = undefined;
	}

	async cancel() {
		let done = true;
		let cancel = true;
		if (this.editor?.tab) {
			if (this.editor.tab.selected.length > 0 && this.editor.tab.selected[0].modified) {
				done = await this.editor.tab.nodeConfirmChanges();
				if (done) {
					this.submit();
					cancel = false;
				}
			}

			if (cancel && this.schemaLink && this.create) {
				await this.editor.tab.linkDelete(this.schemaLink, true);
			}
			if (this.editor.tab.selected.length === 1 && this.selected) {
				this.editor.tab.unselectAll();

				const connection = this.schemaLink?.getConnection();
				if (connection) {
					// @ts-ignore
					$(connection.getOverlay('label').canvas).removeClass('selected');
				}
			}
		}
		this.selected = null;
		this.schemaLink = null;
	}

	emptyCommon() {
		return this.source?.node.kndef.CLASS.COMMON.filter(
			(/** @type {any} */ common) => common.dico_id.split(';')[1] === this.dicoId?.split(';')[1]
				&& common.type === 'link',
		).length === 0 ?? true;
	}

	/**
	 * @param {?import('@knitiv/api-client-javascript').KNode} type
	 * @returns {boolean}
	 */
	isLinkDef(type) {
		return this.editor?.tab?.schema.relations.some(
			(/** @type {any} */ relation) => relation.kid === type && relation.type.length > 0 && relation.type[0] === 'def',
		) || false;
	}

	submit() {
		if (this.schemaLink && this.editor?.tab) {
			this.schemaLink.data = this.tmp.data || {};
			this.schemaLink.from.card = this.tmp.card.from;
			this.schemaLink.to.card = this.tmp.card.to;
			this.editor.tab.linkUpdate(this.schemaLink);
		}
	}

	/**
	 * @param {any} linker
	 */
	updateLinker(linker) {
		if (this.schemaLink) {
			this.schemaLink.linker = linker ? {
				kid:  linker.kid,
				name: linker.name,
			} : { kid: '0', name: undefined };
		}
	}

	updateType() {
		if (this.schemaLink && this.oldType) {
			if (this.isLinkDef(this.schemaLink.type) && !this.isLinkDef(this.oldType)) {
				// convert "link" to "def"
				this.dicoId = this.oldDicoId || this.source?.node.kndef.getNextKey('CLASS', 'DICO') || '';
				this.active = this.dicoId.split(';')[1];
				this.oldType = this.schemaLink.type;
			}
			else if (!this.isLinkDef(this.schemaLink.type) && this.isLinkDef(this.oldType)) {
				// convert "def" to "link"
				this.oldDicoId = this.dicoId;
				this.dicoId = null;
				this.active = '0';
				this.oldType = this.schemaLink.type;
			}
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.selected) {
			this.schemaLink = this.selected ? _.cloneDeep(this.selected.node) : null;
			this.create = this.selected?.options.create || false;
			this.btntitle = this.create ? this.$translate.instant('common.create') : this.$translate.instant('common.modify');

			if (this.schemaLink) {
				this.oldType = this.schemaLink.type;
				this.dicoId = this.schemaLink.dico_id;

				this.source = this.schemaLink?.from?.id ? this.editor?.tab?.schema.getNode(this.schemaLink.from.id) : undefined;
				this.target = this.schemaLink?.to?.id ? this.editor?.tab?.schema.getNode(this.schemaLink.to.id) : undefined;

				this.title = this.disabled
					? this.$translate.instant('designer.view-link')
					: (
						this.create
							? this.$translate.instant('designer.create-link')
							: this.$translate.instant('designer.edit-link')
					);

				let data;
				try {
					data = JSON.parse(this.schemaLink.data || 'null');
				}
				catch {
					data = null;
				}

				this.tmp = {
					linker: this.schemaLink.linker.kid === '0' ? [] : [{ ...this.schemaLink.linker }],
					card:   {
						from: this.schemaLink.from.card,
						to:   this.schemaLink.to.card,
					},
					data,
				};
			}

			this.$timeout(() => {
				this.active = this.dicoId?.split(';')[1] || '0';
				if (this.create) {
					this.form?.$setDirty();
				}
				else {
					this.form?.$setPristine();
				}
			});
		}

		if (changes.disabled) {
			this.options = {
				mode:    this.disabled ? 'view' : 'tree',
				modes:   this.disabled ? ['view'] : [
					'code',
					'form',
					'text',
					'tree',
					'view',
				],
				onError: (/** @type {any} */ error) => {
					this.Notification.warning({
						title:     this.$translate.instant('error.title'),
						message:   error.toString(),
					});
				},
			};
		}
	}

	$onInit() {
		(async () => {
			this.relations = (this.editor?.tab?.schema.relations || [])
				.filter((/** @type {any} */ relation) => !ignoreRelations.has(relation.kid));
		})();

		this.nodes = (this.editor?.tab?.schema?.schemaNodes
			.map((/** @type {import('~/scripts/services/model/schema-node').default} */ n) => ({
				kid:  n.node.kid,
				name: n.node.getName() || '',
			})) || [])
			.filter(
				/**
				 * @param {any} value
				 * @param {number} index
				 * @param {any} self
				 * @returns {boolean}
				 */
				(value, index, self) => index === self.findIndex(
					(/** @type {any} */ t) => t.kid === value.kid,
				),
			)
			.sort(
				/**
				 * @param {any} a
				 * @param {any} b
				 * @returns {number}
				 */
				(a, b) => (ul(a.name) < ul(b.name) ? -1 : (ul(a.name) > ul(b.name) ? 1 : 0)),
			);

		this.$scope.$watch('$ctrl.form.$dirty', () => {
			if (this.selected && this.form) {
				this.selected.modified = this.form.$dirty;
			}
		});
	}
}
